import * as yup from 'yup';
import type { ChangeEvent } from 'react';
import type { ControllerRenderProps, FieldError } from 'react-hook-form';
import { isWidgetOffsetValid, WIDGET_ALIGNMENTS, WIDGET_OFFSET_MAX, WIDGET_OFFSET_MIN } from '@constants/widget';

type Translate = (key: string, params?: Record<string, unknown>) => string;

const OFFSET_INPUT = /^-?\d*$/;

const offsetSchema = yup.string().test('offset-range', 'validation.numberRange', isWidgetOffsetValid);

export const widgetPositionSchemaFields = {
    alignment: yup.string().oneOf(WIDGET_ALIGNMENTS),
    offsetX: offsetSchema,
    offsetY: offsetSchema,
};

export const widgetAlignmentOptions = (t: Translate) =>
    WIDGET_ALIGNMENTS.map(value => ({ value, label: t(`common.${value}`) }));

export const widgetOffsetFieldProps = (field: ControllerRenderProps, error: FieldError | undefined, t: Translate) => ({
    inputProps: {
        ...field,
        value: field.value ?? '',
        inputMode: 'numeric' as const,
        onChange: (e: ChangeEvent<HTMLInputElement>) => {
            if (OFFSET_INPUT.test(e.target.value)) {
                field.onChange(e.target.value);
            }
        },
    },
    error: !!error,
    helperText: error?.message ? t(error.message, { min: WIDGET_OFFSET_MIN, max: WIDGET_OFFSET_MAX }) : null,
});
